export const PROFILE_FIELDS_LOADING = 'PROFILE_FIELDS_LOADING'
export const PROFILE_FIELDS_SUCCESS = 'PROFILE_FIELDS_SUCCESS'
export const PROFILE_FIELDS_FAILED = 'PROFILE_FIELDS_FAILED'